export default __webpack_public_path__ + "static/404_ohno-aa91d0c866ee1a6ba95990ce24bffb9a.svg";